package ai.jessie.web.invoices

import ai.jessie.web.members.deniesAccess
import ai.jessie.web.onboarding.OnboardingRequestFailure

// UC-013 rejections as pure state transitions. Nothing previously loaded survives a tenant denial.
internal fun InvoiceUiState.rejected(
    failure: InvoiceRequestFailure,
    saving: Boolean,
): InvoiceUiState {
    val detail = failure.detail
    val error = failure.invoiceProblem(saving)
    val refreshed = detail.preview
    val draft = draft
    return when {
        // A8, A11 and tenant denial: no customer, project, position, work or invoice detail stays.
        OnboardingRequestFailure(failure.status, detail.code).deniesAccess() ->
            InvoiceUiState(busy = true, error = error)
        // A5, A6: the entered values stay with every correction marked; totals are withdrawn.
        detail.code == "INVALID_INVOICE" -> {
            val problems =
                detail.problems.associate { it.field to invoiceCorrection(it.field, it.reason) }
            copy(preview = null, problems = problems, error = invoiceValidationProblem(problems))
        }
        // A3, A4, A7: the refreshed preview replaces the reviewed positions and totals.
        refreshed != null && draft != null ->
            copy(
                draft = draft.refreshed(refreshed, detail.problems),
                preview = refreshed,
                changes =
                    detail.problems.mapNotNull {
                        changeMessage(it.field, it.reason, draft, options)
                    },
                error = error,
            )
        // A10: the reviewed draft stays for another attempt.
        saving && failure.status >= HTTP_SERVER_ERROR -> copy(error = error)
        else -> copy(preview = null, error = error)
    }
}
